import Button from "@/common/ui/Button";
import { LightText2 } from "@/common/ui/Text";
import { reinviteEmployee } from "@/services/employee.services";
import { toastMessage } from "@/utils/helper/myToast";
import { useEffect, useState } from "react";

const ReInvite = ({ employeeData, employeeId, onClose, afterCall }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any>({});

  useEffect(() => {
    if (employeeData || afterCall) {
      setData({ afterCall, employeeData });
    }
  }, [employeeData, afterCall]);

  const handleReInvite = async () => {
    if (employeeId) {
      setIsLoading(true);
      try {
        const res: any = await reinviteEmployee({ empId: employeeId });
        if (res?.status === 200) {
          const { message, isError } = res.data;
          onClose();
          if (data?.afterCall) {
            setTimeout(() => {
              data.afterCall();
            }, 10);
          }
          toastMessage(message, isError);
        } else {
          console.log("Error", res);
          const { message, isError } = res?.response?.data || {};
          if (message) {
            toastMessage(message, isError);
          } else if (res.message) {
            toastMessage(res.message, true);
          }
        }
      } catch (err) {
        toastMessage("An unexpected error occurred", true);
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (!data) return null;

  return (
    <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-3 md:p-4 relative">
      <div className="px-1 pb-4">
        <LightText2 text={`Are you sure you want to send an invite to ${data?.employeeData?.empId} - ${data?.employeeData?.empName?.label}?`} />
      </div>
      <div className="flex justify-end">
        <div className="flex justify-between gap-4">
          <button className="px-4 py-1.5 rounded text-13 border text-gray-700 hover:bg-gray-100" onClick={onClose} disabled={isLoading}>
            Cancel
          </button>
          <Button onClick={handleReInvite} variant={"primary"} size="small" isLoading={isLoading}>
            Re-invite
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReInvite;
